/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/ban-types */
import { generalFunction } from "./logInvocation";
import { METHOD_METADATA_KEY, MethodMetadata } from "./methodMetadata";
import { ReplacerFn } from "./replacerFn";

export function LogReturnAs<T>(replacer: ReplacerFn<T>): MethodDecorator
{
    return logReturnAsFn as MethodDecorator;

    function logReturnAsFn(target: Object, _key: string | symbol, descriptor: TypedPropertyDescriptor<generalFunction>): TypedPropertyDescriptor<generalFunction> | void
    {
        const methodName = descriptor.value.name;
        const methodMetadata: MethodMetadata = Reflect.getOwnMetadata(METHOD_METADATA_KEY, target, methodName) || {};

        methodMetadata.replacer = replacer;

        Reflect.defineMetadata(METHOD_METADATA_KEY, methodMetadata, target, methodName);

        return descriptor;
    }
}
